import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import styled from 'styled-components';
import asRendition from '../../asRendition';
import { px } from '../../utils';
import { Flex } from '../Flex';
import { Txt } from '../Txt';
var Base = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder: 0 none;\n\tborder-top: ", ";\n\twidth: 100%;\n\theight: 0;\n"], ["\n\tborder: 0 none;\n\tborder-top: ",
    ";\n\twidth: 100%;\n\theight: 0;\n"])), function (props) {
    return px(2 * (props.height || 0.5)) + " " + (props.type || 'solid') + " " + (props.color || props.theme.colors.quartenary.main) + "}";
});
var FlexBase = styled(Base)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tflex: 1 1 0;\n\tmargin: auto;\n"], ["\n\tflex: 1 1 0;\n\tmargin: auto;\n"])));
var BaseDivider = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, otherProps = __rest(_a, ["children", "className"]);
    if (!children) {
        return React.createElement(Base, __assign({ className: className }, otherProps, { ref: ref }));
    }
    if (typeof children !== 'string') {
        throw new Error("The child element of the Divider component must be a string, received: " + typeof children);
    }
    return (React.createElement(Flex, { className: className, width: "100%", flexDirection: "row", justifyContent: "center", ref: ref },
        React.createElement(FlexBase, __assign({}, otherProps)),
        React.createElement(Txt.span, { color: "tertiary.main", px: 3 }, children),
        React.createElement(FlexBase, __assign({}, otherProps))));
});
export var Divider = asRendition(BaseDivider, [], ['color', 'height']);
var templateObject_1, templateObject_2;
